/**
 * Crypto Clicker 게임 코어 익스포트
 * 모든 게임 로직의 진입점
 */

import { GameCore } from '@app-games/core';
import { createInitialState } from './state.js';
import { actionHandlers } from './actions.js';
import { marketSentimentSystem } from './systems/marketSentimentSystem.js';
import { darkPoolSystem } from './systems/darkPoolSystem.js';
import { autoProductionSystem } from './systems/autoProductionSystem.js';
import { goldenEventSystem } from './systems/goldenEventSystem.js';
import { comboSystem } from './systems/comboSystem.js';
import { boosterSystem } from './systems/boosterSystem.js';
import { achievementSystem } from './systems/achievementSystem.js';
import { playTimeSystem } from './systems/playTimeSystem.js';
import type { GameState } from './state.js';
import type { GameAction } from './actions.js';

export type { GameState } from './state.js';
export type { GameAction } from './actions.js';

/**
 * 게임 코어 생성
 * @param debug 디버그 모드 활성화
 */
export function createGameCore(debug = false) {
  const core = new GameCore<GameState, GameAction>({
    createInitialState,
    debug,
    historySize: 100
  });

  // 액션 핸들러 등록
  for (const [type, handler] of Object.entries(actionHandlers)) {
    core.registerAction(type as GameAction['type'], handler as any);
  }

  // 시스템 등록 (순서 중요)
  core.registerSystem(playTimeSystem);            // 플레이 시간 추적
  core.registerSystem(marketSentimentSystem);      // 마켓 센티먼트 (CPS 배율에 영향)
  core.registerSystem(darkPoolSystem);              // 다크풀 경매 (라운드 진행)
  core.registerSystem(autoProductionSystem);       // 자동 생산 (CPS + 자동 탭)
  core.registerSystem(goldenEventSystem);          // 골든 이벤트 출현/만료
  core.registerSystem(comboSystem);                // 콤보 감쇠
  core.registerSystem(boosterSystem);              // 부스터 만료
  core.registerSystem(achievementSystem);          // 업적 달성 체크

  return core;
}
